export const MAX_CODE_PER_SEARCH = 3;
